import React, { useState, useContext, useEffect } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonRow, IonCol, IonItem, IonCard, IonButton, IonModal, IonLabel, IonInput, useIonViewWillEnter, IonBackButton, IonButtons } from '@ionic/react'
import { ConfigContext } from '../../contexts/ConfigContext';
import db from '../../resources/db';
import { toastController } from '@ionic/core';

const CompanyDetails = () => {

    const { Company, setCompany ,getCompany } = useContext(ConfigContext);
    const [ShowModel, setShowModel] = useState(false)

    const [name, setname] = useState("");
    const [address, setaddress] = useState("");
    const [contact, setcontact] = useState("");
    const [gst, setgst] = useState("");

    const gstPattern = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;

    useEffect(() => {
        setname(Company.name);
        setaddress(Company.address);
        setcontact(Company.contact);
        setgst(Company.gst);
    }, [Company])

    const onSubmit = e => {
        e.preventDefault();
        if (!gstPattern.test(gst) && gst.trim().length) {
            toastController.create({
                color: 'danger',
                duration: 2000,
                message: "GST No. is Wrong. Fill the Correct One",
                showCloseButton: true
            }).then(toast => {
                toast.present();
            });

            return;
        }

        let data = { name, address, contact, gst }
        console.log('done', Company , data);
        db.companies.update(1, data).then(res => {
            if (res) {
                toastController.create({
                    color: 'success',
                    duration: 2000,
                    message: `Company Details updated successfully`,
                    showCloseButton: true,
                    position: "top"
                }).then(toast => {
                    toast.present();
                    getCompany().then(res => {
                        setCompany(res);
                        setShowModel(false);
                    })
                });
            }
        })
    }

    const companyform = (
        <>
            <IonRow class='ion-justify-content-center'>
                <IonCol class='ion-align-self-center' sizeMd='8'>
                    <IonCard>
                        <IonItem>
                            <IonCol>Name: </IonCol>
                            <IonCol>{Company.name.length ? Company.name : 'Add Company Name'}</IonCol>
                        </IonItem>
                        <IonItem>
                            <IonCol>Address: </IonCol>
                            <IonCol>{Company.address.length ? Company.address : 'Add Company Address'}</IonCol>
                        </IonItem>
                        <IonItem>
                            <IonCol>Contact: </IonCol>
                            <IonCol>{Company.contact.length ? Company.contact : 'Add Company Contact'}</IonCol>
                        </IonItem>
                        <IonItem>
                            <IonCol>GST Number: </IonCol>
                            <IonCol>{Company.gst}</IonCol>
                        </IonItem>
                    </IonCard>
                    <IonRow>
                        <IonCol offset='5'>
                            <IonButton onClick={() => setShowModel(true)} >Edit</IonButton>
                        </IonCol>
                    </IonRow>

                </IonCol>
            </IonRow>

            <IonModal isOpen={ShowModel} cssClass='companyUpdate' onDidDismiss={() => setShowModel(false)} >
                <h4 className='ion-text-center'>Edit Company Details</h4>
                <form onSubmit={onSubmit} className='ion-justify-content-center ion-padding'>
                    <IonItem>
                        <IonLabel position='floating'>Company Name</IonLabel>
                        <IonInput autocomplete='on' type="text" required id='name' value={name} onIonInput={(e) => setname((e.target.value).trim())} />
                    </IonItem>
                    <IonItem>
                        <IonLabel position='floating'>Company Address</IonLabel>
                        <IonInput autocomplete='on' type="text" required id='address' value={address} onIonInput={(e) => setaddress((e.target.value).trim())} />
                    </IonItem>
                    <IonItem>
                        <IonLabel position='floating'>Company Contact</IonLabel>
                        <IonInput autocomplete='on' type="text" required id='contact' value={contact} onIonInput={(e) => setcontact((e.target.value).trim())} />
                    </IonItem>
                    <IonItem>

                        <IonLabel position='floating'>Company GST Number</IonLabel>
                        <IonInput autocomplete='on' type="text" id='contact' value={gst} onIonInput={(e) => setgst((e.target.value).trim())} />
                    </IonItem>
                    <IonRow>
                        <IonCol offset='4.5'>
                            <IonButton class='ion-padding' color='danger' type='submit'>Submit</IonButton>
                        </IonCol>
                    </IonRow>

                </form>
            </IonModal>
        </>
    )
    return (
        <IonPage>

            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Company Details</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                {companyform}
            </IonContent>
        </IonPage>
    )
}

export default CompanyDetails
